import {
  getExternalSectionIds,
  type IEngineSection,
} from '@framework/engine/schema/sections/IEngineSection.ts';
import { FormValidatorBuilder } from '@framework/engine/validator/form-builder/FormValidatorBuilder.ts';
import { replaceSectionsSchemaWithMixed } from '@framework/engine/validator/form-builder/replaceSectionsSchemaWithMixed.ts';
import { useMemo } from 'react';

export interface IUseModuleFormValidationSchemaArgs {
  sections: IEngineSection[];
  isReadonly: boolean;
}

/**
 * Hook che costruisce lo schema di validazione del form del modulo,
 * sostituendo le sezioni condivise provenienti da altri moduli
 * (`shared.type === 'external'`) con `yup.mixed()` in modo che i loro valori
 * vengano preservati senza essere modificati né validati.
 */
export function useModuleFormValidationSchema({
  sections,
  isReadonly,
}: IUseModuleFormValidationSchemaArgs) {
  return useMemo(() => {
    const { schema } = FormValidatorBuilder.buildSections(sections, {
      isReadonly,
    });

    const finalSchema = replaceSectionsSchemaWithMixed(
      schema,
      getExternalSectionIds(sections),
    );

    return { schema: finalSchema };
  }, [sections, isReadonly]);
}
